<template lang="pug">
l-control(:position="position" class="leaflet-control-pan")
	//- 3x3 div matrix
	div(id="matrix-container")
		div(v-for="i in 3" class="matrix matrix-row")
			div(v-for="j in 3" class="matrix matrix-col")
				button(v-if="isValidButtonPlacement(i, j)"
					class="leaflet-control-pan-up"
					:direction-index="directionIndexFromIndices(i, j)"
					@click="handleClick($event)")
					i(:class="iconClass(directionIndexFromIndices(i, j))")
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";
import { LControl } from "vue2-leaflet";

// prop default values
const DEFAULT_LEAFLET_POSITION = "topleft";
// prop definitions
const mapProps = {
	position: {
		type: String,
		default: () => DEFAULT_LEAFLET_POSITION
	}
};
@Component({
	props: mapProps,
	components: {
		LControl
	}
})
class MapPanControl extends Vue {
	// used to assign arrow icons to pan button
	iconMap = ["up", "right", "down", "left"];

	/**
	 * assign fontawesome arrow icon that
	 * corresponds to the direction it
	 * controls
	 */
	iconClass(directionIndex) {
		return `fa fa-caret-${this.iconMap[directionIndex]}`;
	}

	/**
	 * will emit a pan click event for the TfmMap component to
	 * consume, and move the map in the desired direction.
	 *
	 * @param { ClickEvent } event get the button's "direction-index"
	 * attribute through event.target.attributes;
	 *
	 * "direction-index" maps to "directionIndexMap" indices,
	 * which are passed to the event emitter
	 */
	handleClick(event) {
		let directionIndex = event.target.attributes["direction-index"].value;
		// let point = { ...this.directionIndexMap[directionIndex] };
		this.$emit("pan-control-click", directionIndex);
	}

	/**
	 * used to set a property on a pan button;
	 * which in turn will be used to retrieve
	 * the coord pair to move the map in the correct
	 * direction
	 *
	 * direction indices go counter-clockwise from 0-4
	 * 0: up
	 * 1: right
	 * 2: down
	 * 3: left
	 *
	 * @param {number} i row index within the 3x3 div matrix
	 * @param {number} j column index in div matrix
	 * @returns {number} the index of direction matching a
	 */
	directionIndexFromIndices(i, j) {
		let directionIndex = -1; // not valid by default
		switch (i + j) {
			// up or left
			case 3:
				// left
				if (i > j) directionIndex = 3;
				// up
				else directionIndex = 0;
				break;
			// down or right
			case 5:
				// down
				if (i > j) directionIndex = 2;
				// right
				else directionIndex = 1;
				break;
			default:
				break;
		}
		return directionIndex;
	}

	/**
	 * logic to determine where buttons
	 * should be placed within a 3x3
	 * matrix of divs, to create a "cross"
	 *
	 * @param {*} i row iterator
	 * @param {*} j column iterator
	 *
	 * @returns boolean of whether a
	 * control button should be placed there
	 */
	isValidButtonPlacement(i, j) {
		// odd row, even column; vice versa
		return (i % 2 == 0 && j % 2 == 1) || (i % 2 == 1 && j % 2 == 0);
	}
}

export default MapPanControl;
</script>

<style scoped>
l-control {
	display: flex;
}

div.matrix {
	/* 
		disable click events:
		these containers are slightly
		off-kilter with the buttons
		they contain, so they end
		up overlapping the buttons,
		rendering them un-clickable
	*/
	pointer-events: none;
}

div.matrix.matrix-col {
	width: 30px;
	height: 30px;
}

div.matrix.matrix-row {
	display: flex;
	flex-wrap: wrap;
	flex: 1 1 auto;
}

i.fa {
	/* prevent click */
	pointer-events: none;
}

button {
	width: 30px;
	height: 30px;
	background-color: #ececeb;
	border: 5px solid #c5c3bf;
	border-radius: 10px;
	color: black;
	/* force button to be clickable */
	pointer-events: auto;
}

button:hover {
	background-color: #09f;
}
</style>
